import { render, staticRenderFns } from "./CompetenceSkills.vue?vue&type=template&id=42b99656&scoped=true&"
import script from "./CompetenceSkills.vue?vue&type=script&lang=js&"
export * from "./CompetenceSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b99656",
  null
  
)

export default component.exports